import { Api, ApiResponse } from "common";
import {
  EligibleVoucherPayload,
  EligibleVoucherResponse,
  VoucherValidationPayload,
} from "./types";

const getValidVoucher = (
  params: VoucherValidationPayload
): ApiResponse<null> => {
  return Api.post("/api/ecomm/voucher/validate_voucher", params);
};

const getEligibleVoucher = (
  params: EligibleVoucherPayload
): ApiResponse<EligibleVoucherResponse> => {
  return Api.post("/api/ecomm/voucher/eligible/get", params);
};

export const VoucherApi = {
  getValidVoucher,
  getEligibleVoucher,
};
